import React, { useState } from 'react'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import LinkedUserSearch from './LinkedUserSearch'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import '../../Settings/SettingsViews/SettingsListView.scss'

const LinkedUserAccounts = ({ updatePayorValue, linkedAccounts = [], checkConnected }) => {
  const [userSearchModalOpen, setUserSearchModalOpen] = useState(false)

  const updateAndCloseModal = (selectedUsers) => {
    setUserSearchModalOpen(false)
    updatePayorValue('LinkedUserAccounts', selectedUsers)
  }

  const columns = [
    {
      field: 'Name',
      flex: 1,
      headerName: 'Name',
      disableColumnMenu: true,
    },
    {
      field: 'Email',
      flex: 1,
      headerName: 'Email',
      disableColumnMenu: true,
    }
  ]

  return (
    <div>
      <div className="property-label distribution-header">
        {'Linked User Accounts'}
        <ContextButton variant={'primary'} onClick={() => setUserSearchModalOpen(true)}>
          Add/Remove Users
        </ContextButton>
      </div>
      <GraniteDataGrid getRowId={(row) => row.UserId} columns={columns} rows={linkedAccounts} />
      <br />
      <br />
      <br />
      <Portal isOpened={userSearchModalOpen}>
        <Modal
          title="Linked User Accounts"
          modalSize="extra-large"
          cancelButton
          autoHeight
          closeModal={() => setUserSearchModalOpen(false)}
        >
          <LinkedUserSearch
            updateAndCloseModal={updateAndCloseModal}
            linkedAccounts={linkedAccounts}
            checkConnected={checkConnected}
          />
        </Modal>
      </Portal>
    </div>
  )
}

export default LinkedUserAccounts
